module.exports = __webpack_public_path__ + "img/ewm1.99187633.jpg";